export default "__VITE_ASSET__BsiJV6Ch__"